import { Feature } from 'shared/models';

//
//  Action Constants
//

export const Actions = {
    FEATURES_LOADED: 'FEATURES_LOADED',
};


//
//  Action Creators
//

export const featuresLoaded = (features: Feature[]) => ({
    type: Actions.FEATURES_LOADED,
    payload: features,
});
